export function getFullOffsetOfElement(element: HTMLElement): number {
  const offsetParent = element.offsetParent
  if (!(offsetParent instanceof HTMLElement)) {
    return 0
  }
  return element.offsetTop + getFullOffsetOfElement(offsetParent)
}
